import React from 'react';
import MTooltipIcon from 'components/common/MTooltipIcon';
import Icon from '../../../Icon';
import DelaySlider from '../DelaySlider';
import * as utils from '../_utils';

export default ({
  onToggle,
  toggled,
  DOMRef,
  onDelayChange,
  value,
  onDelete,
}) => {
  const toggledClassName = toggled ? 'toggled' : '';
  return (
    <div className="bot-says-card-header" ref={DOMRef} onClick={onToggle}>
      <div className="bot-says-card-header-row">
        <Icon iconType="delay" className="bot-says-card-header-row-icon" />
        <div className="bot-says-card-header-row-title">
          Follow-Up Message ({utils.getHumanReadableDurationFull(value.time)})
        </div>
        <div className="bot-says-card-header-row-subtitle">
          <MTooltipIcon>
            This is used to prompt/wakeup the user if he is inactive for a
            defined time.
          </MTooltipIcon>
        </div>
        <div className="bot-says-card-header-row-cta">
          <Icon
            onClick={onDelete}
            iconType="trash"
            className="bot-says-card-header-row-cta-icon"
          />
          <Icon
            onClick={onToggle}
            iconType="angle-down"
            className={`bot-says-card-header-row-cta-icon ${toggledClassName}`}
            tooltip={!toggled ? 'Expand' : 'Collapse'}
          />
        </div>
      </div>
      {toggled ? (
        <DelaySlider
          start={1}
          end={1200}
          value={value.time}
          onChange={onDelayChange}
        />
      ) : null}
    </div>
  );
};
